<template>
  <div class="modal fade" id="baby_name_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">Parent Details</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="name">Name</label>
            <input v-model="customer.name" type="text" readonly class="form-control" placeholder="Name...">
          </div>
          <div class="form-group">
            <label for="contactNumber">Contact Number</label>
            <input v-model="customer.contactNumber" type="text" readonly class="form-control" placeholder="Contact Number...">
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input v-model="customer.email" type="email" readonly class="form-control" placeholder="Email...">
          </div>
          <div class="form-group">
            <label for="customerStatus">Status</label>
            <input v-model="customer.customerStatus" type="text" readonly class="form-control" placeholder="Status...">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {getCustomerDetails, getCustomerBabies, updateBabyDetails, getBabyDetails} from "@/api/babynames";
import Multiselect from "vue-multiselect";
import {BabyNameStatuses} from "@/Utils/Constants/BabyNameStatuses";

export default {
  name: "EditCustomerBabyName",
  components: {Multiselect},
  data:function() {
    return {
      baby: {
        "babyId": 0,
        "customerName": "",
        "babyName": "",
        "dateOfBirth": "",
        "gender": "",
        "status": "",
      },
      customer: {
        name: '',
        contactNumber: '',
        email: '',
        customerStatus: ''
      },
      disableStatus: false
    };
  },
  computed: {
    BabyNameStatuses() {
      return BabyNameStatuses
    },
    gender() {
      return this.baby.gender === 'M' ? 'Boy' : 'Girl'
    },
  },
  methods: {

    async load(id) {
      try {
        const response = await getCustomerDetails(id);
        this.customer = {
          name: response.data.body.name,
          contactNumber: response.data.body.contactNumber,
          email: response.data.body.email,
          customerStatus: response.data.body.customerStatus,
        };

        $("#baby_name_modal").modal("show");
      } catch (ex) {
        this.showErrorMessage(ex);
      }
    },
  }
}
</script>

<style scoped>
.style-textarea {
  resize: vertical;
  width: 100%;
  padding: 6px;
  height: 100px !important;
}
</style>